import { Snowflake } from "lucide-react";

export default function ColdSnapBanner({ onBook }) {
  const month = new Date().getMonth();
  if (month < 5 || month > 7) return null;
  return (
    <div className="bg-tpeco-ink text-white py-2.5 px-4 flex items-center justify-center gap-2 text-center" data-testid="cold-snap-banner">
      <Snowflake className="w-4 h-4 text-tpeco-blue shrink-0 animate-pulse" strokeWidth={2.5} />
      <p className="text-[11px] sm:text-sm font-bold uppercase tracking-wide">
        COLD SNAP ALERT: Perth mornings have turned brutal — dead hot water units don't fix themselves.
        <button onClick={onBook} className="ml-2 text-tpeco-pink underline decoration-2 underline-offset-2 hover:text-white transition-colors" data-testid="cold-snap-book-link">
          GRAB A SAME-DAY SLOT →
        </button>
      </p>
    </div>
  );
}
